<nz-layout class="app-layout">
  <nz-sider class="menu-sidebar"
            nzCollapsible
            nzWidth="200px"
            nzBreakpoint="md"
            [(nzCollapsed)]="isCollapsed"
            [nzTrigger]="null">
    <div class="sidebar-logo">
      <a routerLink="/" target="_blank" rel="noopener noreferrer">
        <img src="assets/logo/mp_logo_300_300.png" alt="logo">
        <h1>{{ 'shell.base_layout.brand' | transloco }}</h1>
      </a>

    </div>
    <ul nz-menu class="menu" nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed" [nzSelectable]="false">
      <li nz-submenu nzOpen nzIcon="thunderbolt" [nzTitle]="'shell.base_layout.navigation.site.title' | transloco">
        <ul>
          <li nz-menu-item [nzSelected]="activeMenuKey() === 'siteList'">
            <a routerLink="/site/list">{{ 'shell.base_layout.navigation.site.list' | transloco }}</a>
          </li>
        </ul>
      </li>

      <li nz-submenu nzOpen nzIcon="cloud-server" [nzTitle]="'shell.base_layout.navigation.device.title' | transloco">
        <ul>
          <li nz-menu-item [nzSelected]="activeMenuKey() === 'deviceList'">
            <a routerLink="/device/list">{{ 'shell.base_layout.navigation.device.list' | transloco }}</a>
          </li>
          <li nz-menu-item [nzSelected]="activeMenuKey() === 'deviceGroup'">
            <a routerLink="/device-group/list">{{ 'shell.base_layout.navigation.device.group' | transloco }}</a>
          </li>
          <li nz-menu-item [nzSelected]="activeMenuKey() === 'dongleList'">
            <a routerLink="/device/dongle-list">{{ 'shell.base_layout.navigation.device.dongle' | transloco }}</a>
          </li>
          <li nz-menu-item [nzSelected]="activeMenuKey() === 'deviceEvent'">
            <a routerLink="/device/event">{{ 'shell.base_layout.navigation.device.event' | transloco }}</a>
          </li>
          <li nz-menu-item [nzSelected]="activeMenuKey() === 'deviceBattery'">
            <a routerLink="/device/battery">{{ 'shell.base_layout.navigation.device.battery' | transloco }}</a>
          </li>
          <li nz-menu-item [nzSelected]="activeMenuKey() === 'deviceModel'">
            <a routerLink="/device/model">{{ 'shell.base_layout.navigation.device.model' | transloco }}</a>
          </li>
          <li nz-menu-item [nzSelected]="activeMenuKey() === 'deviceMqttData'">
            <a routerLink="/device/iot-mqtt-data-list">{{ 'shell.base_layout.navigation.device.mqtt_data' | transloco }}</a>
          </li>
          <li nz-menu-item [nzSelected]="activeMenuKey() === 'deviceSgccCsrs'">
            <a routerLink="/device/sgcc-csrs">{{ 'shell.base_layout.navigation.device.sgcc_csr' | transloco }}</a>
          </li>
        </ul>
      </li>

      @if (isPrimaryRegion()) {
        <li nz-submenu nzOpen nzIcon="cloud-upload" [nzTitle]="'shell.base_layout.navigation.ota.title' | transloco">
          <ul>
            <li nz-menu-item [nzSelected]="activeMenuKey() === 'deviceFirmware'">
              <a routerLink="/device/firmware">{{ 'shell.base_layout.navigation.ota.firmware' | transloco }}</a>
            </li>
            <li nz-menu-item [nzSelected]="activeMenuKey() === 'deviceGridCodes'">
              <a routerLink="/device/grid-codes">{{ 'shell.base_layout.navigation.ota.grid_code' | transloco }}</a>
            </li>
          </ul>
        </li>
      }

      <li nz-submenu nzOpen nzIcon="shop" [nzTitle]="'shell.base_layout.navigation.isp.title' | transloco">
        <ul>
          <li nz-menu-item [nzSelected]="activeMenuKey() === 'ispList'">
            <a routerLink="/isp/list">{{ 'shell.base_layout.navigation.isp.list' | transloco }}</a>
          </li>
        </ul>
      </li>

      <li nz-submenu nzIcon="file-text" [nzTitle]="'shell.base_layout.navigation.system.title' | transloco">
        <ul>
          <li nz-menu-item [nzSelected]="activeMenuKey() === 'systemNotification'">
            <a routerLink="/system-status/notification-list">{{ 'shell.base_layout.navigation.system.notification' | transloco }}</a>
          </li>
          <li nz-menu-item [nzSelected]="activeMenuKey() === 'systemLog'">
            <a routerLink="/system-status/audit-log-list">{{ 'shell.base_layout.navigation.system.log' | transloco }}</a>
          </li>
        </ul>
      </li>
      <li nz-submenu nzOpen nzIcon="team" [nzTitle]="'shell.base_layout.navigation.account.title' | transloco">
        <ul>
          <li nz-menu-item [nzSelected]="activeMenuKey() === 'accountUserList'">
            <a routerLink="/account-management/user-list">{{ 'shell.base_layout.navigation.account.user_list' | transloco }}</a>
          </li>
          @if (canManageRoles()) {
            <li nz-menu-item [nzSelected]="activeMenuKey() === 'accountRoleList'">
              <a routerLink="/account-management/role-list">{{ 'shell.base_layout.navigation.account.role_list' | transloco }}</a>
            </li>
          }
          <li nz-menu-item>
            <a [href]="accountProfileUrl()" target="_blank" rel="noopener noreferrer">
              {{ 'shell.base_layout.navigation.account.mp_auth' | transloco }}
              <span class="menu-external-link-icon" nz-icon nzType="export" aria-hidden="true"></span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
  </nz-sider>
  <nz-layout>
    <nz-header>
      <div class="app-header">
        <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
            <span class="trigger"
                  nz-icon
                  [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
            ></span>
        </span>
        <app-header></app-header>
      </div>
    </nz-header>
    <nz-content>
      <div class="inner-content">
        @for (epoch of [regionEpoch()]; track epoch) {
          <router-outlet></router-outlet>
        }
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
